import { useCallback as d } from "react";
import { normalizeEventKey as f, dataAttr as y } from "../../../utils/dom/index.js";
import { callAllHandlers as i } from "../../../utils/function/index.js";
import { useMenuContext as w } from "../useMenuContext.js";
const I = (n = {}) => {
  const {
    buttonId: s,
    menuId: c,
    onToggle: u,
    openAndFocusFirstItem: e,
    openAndFocusLastItem: a,
    opened: t,
    setButtonRef: p
  } = w(), l = d(
    (o) => {
      const m = f(o), r = {
        ArrowDown: e,
        ArrowUp: a
      }[m];
      r && (o.preventDefault(), o.stopPropagation(), r(o));
    },
    [e, a]
  );
  return {
    ...n,
    "aria-controls": c,
    "aria-expanded": t,
    "aria-haspopup": "menu",
    "data-active": y(t),
    opened: t,
    id: s,
    ref: p,
    onClick: i(n.onClick, u),
    onKeyDown: i(n.onKeyDown, l)
  };
};
export {
  I as useMenuButton
};
//# sourceMappingURL=useMenuButton.js.map
